import { createActions } from 'redux-actions';

export default createActions({
  USER: {
    UPDATE: undefined,
    RESET: undefined,
  },
  CHANNEL: {
    UPDATE: undefined,
  },
  CART: {
    TOGGLE: undefined,
    ADD: item => ({ item }),
    EDIT: item => ({ item, editMode: true }),
    REMOVE: id => ({ id }),
    RECOVER: items => ({ items }),
    RESET: undefined,
  },
  SCANNER: {
    TOGGLE: undefined,
    CLOSE: undefined,
    TYPE: {
      CHANGE: type => ({ type }),
    },
  },
  PRODUCT_MODAL: {
    OPEN: info => ({ active: true, ...info }),
    CLOSE: () => ({
      active: false,
      productId: '',
      quantity: 0,
      productDiscount: {},
      editMode: false,
    }),
  },
  PRODUCTS: {
    FETCH: {
      TOGGLE: undefined,
    },
    ADD: undefined,
  },
  DISCOUNT_MODAL: {
    OPEN: undefined,
    CLOSE: undefined,
  },
  SEARCH_KEYWORD: {
    EDIT: undefined,
  },
  DRAWER: {
    TOGGLE: undefined,
  },
  ORDER: {
    RESET: undefined,
    SUBMIT: {
      ENABLE: undefined,
      DISABLE: undefined,
    },
    CUSTOM_PRICE: {
      TOGGLE: undefined,
      EDIT: customPrice => ({ customPrice }),
    },
    DISCOUNT: {
      EDIT: discount => ({ discount }),
    },
    PRICE: {
      EDIT: price => ({ price }),
    },
    POINTS: {
      RESET: undefined,
      USE: undefined,
    },
  },
  MEMBER: {
    RESET: undefined,
    UPDATE: undefined,
    MODAL: {
      TOGGLE: undefined,
    },
  },
  PRE_ORDER: {
    ENABLE: undefined,
    LIST: {
      TOGGLE: undefined,
      UPDATE: undefined,
    },
    DETAIL: {
      TOGGLE: undefined,
      RESET: undefined,
      UPDATE: undefined,
    },
  },
  PAYMENT: {
    CHECK: {
      ENABLE: () => ({ checking: true }),
      DISABLE: () => ({ checking: false }),
    },
    UPDATE: undefined,
    RESET: undefined,
  },
  ORDER_STEP: {
    EDIT: undefined,
    RESET: undefined,
  },
  ORDER_DETAIL: {
    TOGGLE: undefined,
  },
  RECEIPT: {
    EDIT: undefined,
    RESET: undefined,
  },
  INVOICE: {
    SUBMIT: {
      ENABLE: undefined,
      DISABLE: undefined,
    },
    STATUS: {
      EDIT: status => ({ status }),
    },
    VAT_ID: {
      EDIT: vatId => ({ vatId }),
    },
    MODAL: {
      TOGGLE: undefined,
    },
    RESET: undefined,
  },
});



// WEBPACK FOOTER //
// ./src/actions/index.js